import React from "react";
import WhoToFollowListItem from "./WhoToFollowListItem.js";
import {useSelector} from "react-redux";


const WhoToFollowList = () => {
  const whos = useSelector((state) => state.who);
  return(
      <div>
          <li className={`list-group-item mt-2`}>Who to follow</li>
          <div className={`container-fluid`}>
            <ul className={`list-group wd-font-15`}>
              {
                whos.map(who=>{
                  return(
                      <WhoToFollowListItem who={who}/>
                  );
                })
              }
            </ul>
          </div>
      </div>
    );
}

export default WhoToFollowList;